









import { Component, Vue, Prop } from 'vue-property-decorator'
import { childText } from '@/views/analys/analyChart/coms/pageBottomText'
import PageButtomText from '@/components/pageBottomText/index.vue'
import PageSection from './coms/plan.vue'
import OtherSection from './coms/others.vue'

@Component({
  name: 'printChild',
  components: {
    PageSection,
    OtherSection,
    PageButtomText
  }
})

export default class extends Vue {
  @Prop() private onlyChild!: boolean
  childText = childText
}
